import { useAsset } from '@/hooks/useAsset'
import type { ComponentPropsWithoutRef } from 'react'

export function Svg({
	url,
	sprite,
	bounds,
	ariaLabel,
	ariaHidden = true,
	...props
}: ComponentPropsWithoutRef<'svg'> & {
	url: string
	sprite?: string
	bounds?: { x: number; y: number; width: number; height: number }
	ariaLabel?: string
	ariaHidden?: boolean
}) {
	sprite ??= url.split('/').at(-1)!.split('.')[0]

	return (
		<svg
			aria-hidden={ariaHidden}
			aria-label={ariaLabel}
			viewBox={
				bounds
					? `${bounds.x} ${bounds.y} ${bounds.width} ${bounds.height}`
					: undefined
			}
			{...props}
		>
			<use href={url + '#' + sprite} {...bounds} />
		</svg>
	)
}

export function AssetSvg({
	name,
	...props
}: Omit<Parameters<typeof Svg>[0], 'url'> & { name: string }) {
	const asset = useAsset(name) ?? 'data:image/svg+xml,<svg />'
	return <Svg url={asset} data-asset={name} {...props} />
}
